// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UZ7rv8ERxke4RAV_E_2B[data-has-many='true'] .ZhjDYY6oii0zzJMvT6mQ {
  width: 45px;
  height: 45px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .UZ7rv8ERxke4RAV_E_2B[data-has-many='true'] .ZhjDYY6oii0zzJMvT6mQ {
    width: 30px;
    height: 30px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .UZ7rv8ERxke4RAV_E_2B[data-has-many='true'][data-view='multi'][data-variant='card'] .ZhjDYY6oii0zzJMvT6mQ {
    width: 25px;
    height: 25px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .UZ7rv8ERxke4RAV_E_2B[data-has-many='true'][data-view='multi'][data-variant='card'] .ZhjDYY6oii0zzJMvT6mQ {
    width: 25px;
    height: 25px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PrizeFundCampaign/CampaignBadge/css/hasManyStyles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;AAAA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AAAA;AAAA;AAAA","sourcesContent":[".wrapper[data-has-many='true'] .image {\n  width: 45px;\n  height: 45px;\n}\n@media (--campaign-mobile) {\n  .wrapper[data-has-many='true'] .image {\n    width: 30px;\n    height: 30px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  .wrapper[data-has-many='true'][data-view='multi'][data-variant='card'] .image {\n    width: 25px;\n    height: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `UZ7rv8ERxke4RAV_E_2B`,
	"image": `ZhjDYY6oii0zzJMvT6mQ`
};
export default ___CSS_LOADER_EXPORT___;
